/* IronRidge homepage, header & footer behaviour (irh-*). */
(function () {
  if (window.__irhInit) return;
  window.__irhInit = true;

  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* Countdown: data-end (ISO) or, when empty, the end of the current day. */
  function initCountdown(root) {
    if (root.dataset.irhReady) return;
    root.dataset.irhReady = '1';
    var end = Date.parse(root.dataset.end || '');
    if (isNaN(end)) { var d = new Date(); d.setHours(24, 0, 0, 0); end = d.getTime(); }
    var h = root.querySelector('[data-cd="h"]'), m = root.querySelector('[data-cd="m"]'), s = root.querySelector('[data-cd="s"]');
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      h.textContent = pad(Math.floor(left / 3600e3));
      m.textContent = pad(Math.floor(left / 60e3) % 60);
      s.textContent = pad(Math.floor(left / 1e3) % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* Header: shop dropdown, mobile drawer, predictive search */
  function initHeader(root) {
    if (root.dataset.irhReady) return;
    root.dataset.irhReady = '1';
    var shops = root.querySelectorAll('[data-irh-shop]');
    var drawer = root.querySelector('[data-irh-drawer]');
    var search = root.querySelector('[data-irh-search]');
    var input = search && search.querySelector('input[type="search"]');

    /* One dropdown per menu link that has sub-links; opening one closes the others. */
    function setShop(target) {
      if (target) closeCountries(null);
      shops.forEach(function (shop) {
        var open = shop === target;
        shop.classList.toggle('is-open', open);
        shop.querySelector('button').setAttribute('aria-expanded', String(open));
        shop.querySelector('.irh-mega').hidden = !open;
      });
    }
    shops.forEach(function (shop) {
      var btn = shop.querySelector('button');
      btn.addEventListener('click', function () { setShop(shop.classList.contains('is-open') ? null : shop); });
      btn.addEventListener('mouseenter', function () { setShop(shop); });
    });
    if (shops.length) {
      root.querySelectorAll('[data-irh-close-shop]').forEach(function (el) { el.addEventListener('mouseenter', function () { setShop(null); }); });
      root.addEventListener('mouseleave', function () { setShop(null); });
    }

    function setDrawer(open) {
      if (!drawer) return;
      drawer.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    root.querySelectorAll('[data-irh-open-menu]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
    root.querySelectorAll('[data-irh-close-menu]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    root.querySelectorAll('[data-irh-sub]').forEach(function (subBtn) {
      subBtn.addEventListener('click', function () {
        var open = subBtn.getAttribute('aria-expanded') !== 'true';
        subBtn.setAttribute('aria-expanded', String(open));
        document.getElementById(subBtn.getAttribute('aria-controls')).hidden = !open;
      });
    });

    /* Country/region picker: toggle the list, submit the localization form on pick */
    var countryForms = root.querySelectorAll('.irh-country');
    function closeCountries(except) {
      countryForms.forEach(function (f) {
        if (f === except) return;
        var t = f.querySelector('[data-irh-country-toggle]');
        t.setAttribute('aria-expanded', 'false');
        f.querySelector('.irh-country__list').hidden = true;
      });
    }
    countryForms.forEach(function (f) {
      var toggle = f.querySelector('[data-irh-country-toggle]');
      var list = f.querySelector('.irh-country__list');
      function setCountry(open) {
        closeCountries(f);
        if (open) setShop(null);
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      }
      toggle.addEventListener('click', function () { setCountry(list.hidden); });
      /* Desktop header picker opens on hover like Shop Now; the drawer one stays tap-only */
      if (!f.classList.contains('irh-country--drawer')) {
        f.addEventListener('mouseenter', function () { setCountry(true); });
        f.addEventListener('mouseleave', function () { setCountry(false); });
      }
      f.querySelectorAll('[data-irh-country]').forEach(function (b) {
        b.addEventListener('click', function () {
          f.querySelector('input[name="country_code"]').value = b.dataset.irhCountry;
          f.submit();
        });
      });
    });
    if (countryForms.length) document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.irh-country')) closeCountries(null);
    });

    function setSearch(open) {
      if (!search) return;
      search.hidden = !open;
      if (open) { setDrawer(false); setShop(null); document.documentElement.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 30); }
      else document.documentElement.style.overflow = '';
    }
    root.querySelectorAll('[data-irh-open-search]').forEach(function (b) { b.addEventListener('click', function () { setSearch(true); }); });
    root.querySelectorAll('[data-irh-close-search]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      setSearch(false); setShop(null); setDrawer(false); closeCountries(null);
    });

    if (search) initSearch(search, input);
  }

  function initSearch(search, input) {
    var cfg = JSON.parse(search.querySelector('[data-irh-search-config]').textContent);
    var form = search.querySelector('form');
    var clear = search.querySelector('[data-irh-clear]');
    var popular = search.querySelector('[data-irh-popular]');
    var depts = search.querySelector('[data-irh-depts]');
    var deptList = depts.querySelector('[data-irh-dept-list]');
    var results = search.querySelector('[data-irh-results]');
    var label = search.querySelector('[data-irh-results-label]');
    var count = search.querySelector('[data-irh-results-count]');
    var list = search.querySelector('[data-irh-results-list]');
    var trending = list.innerHTML;
    var empty = search.querySelector('[data-irh-empty]');
    var emptyQ = search.querySelector('[data-irh-empty-q]');
    var all = search.querySelector('[data-irh-all]');
    var allQ = search.querySelector('[data-irh-all-q]');
    var timer, seq = 0;

    var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var money = function (v) {
      var n = Number(v);
      if (!isFinite(n)) return '';
      var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return cfg.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
    };

    function render(q, products) {
      var toks = q.toLowerCase().split(/\s+/).filter(Boolean);
      var has = toks.length > 0;
      clear.hidden = !has;
      popular.hidden = has;
      var hits = has ? cfg.depts.filter(function (d) { return toks.some(function (t) { return d.label.toLowerCase().indexOf(t) > -1; }); }) : [];
      depts.hidden = !hits.length;
      deptList.innerHTML = hits.map(function (d) { return '<a class="irh-chip irh-chip--dept" href="' + esc(d.url) + '">' + esc(d.label) + '</a>'; }).join('');
      all.hidden = !has;
      allQ.textContent = q.trim();
      all.href = cfg.searchUrl + '?q=' + encodeURIComponent(q.trim());
      if (!has) {
        list.innerHTML = trending;
        label.textContent = cfg.trendingLabel;
        count.textContent = '';
        results.hidden = !trending.trim();
        empty.hidden = true;
        return;
      }
      if (!products) return;
      label.textContent = 'Products';
      count.textContent = products.length + (products.length === 1 ? ' result' : ' results');
      results.hidden = !products.length;
      empty.hidden = !!products.length;
      emptyQ.textContent = q.trim();
      list.innerHTML = products.map(function (p) {
        var name = esc(p.title) + '<mark></mark>';
        var lo = Number(p.price_min || p.price), hi = Number(p.price_max || p.price);
        var price = hi > lo ? money(lo) + '–' + money(hi) : money(lo);
        var cmp = Number(p.compare_at_price_min || p.compare_at_price_max || 0);
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        return '<li><a class="irh-search__item" href="' + esc(p.url) + '">' +
          '<span class="irh-search__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
          '<span class="irh-search__meta"><span class="irh-search__name">' + name + '</span>' +
          '<span class="irh-search__prices"><span class="irh-search__price">' + price + '</span>' + (cmp > lo ? '<s>' + money(cmp) + '</s>' : '') + '</span></span></a></li>';
      }).join('');
    }

    function query(q) {
      var mine = ++seq;
      if (!q.trim()) { render(q); return; }
      render(q);
      fetch(cfg.suggestUrl + '?q=' + encodeURIComponent(q.trim()) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (j) { if (mine === seq) render(q, (j.resources && j.resources.results && j.resources.results.products) || []); })
        .catch(function () { if (mine === seq) render(q, []); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { query(input.value); }, 180); });
    clear.addEventListener('click', function () { input.value = ''; query(''); input.focus(); });
    search.querySelectorAll('[data-irh-pick]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.dataset.irhPick; query(input.value); input.focus(); });
    });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  }

  /* Reviews rail arrows */
  function initRail(root) {
    if (root.dataset.irhReady) return;
    root.dataset.irhReady = '1';
    var rail = root.querySelector('[data-irh-rail]');
    root.querySelectorAll('[data-irh-dir]').forEach(function (b) {
      b.addEventListener('click', function () { rail.scrollBy({ left: Number(b.dataset.irhDir) * rail.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  }

  /* FAQ: one panel open at a time */
  function initFaq(root) {
    if (root.dataset.irhReady) return;
    root.dataset.irhReady = '1';
    var btns = root.querySelectorAll('.irh-faq__q');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') !== 'true';
        btns.forEach(function (o) {
          var on = o === b && open;
          o.setAttribute('aria-expanded', String(on));
          document.getElementById(o.getAttribute('aria-controls')).hidden = !on;
        });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-irh-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-irh-header]').forEach(initHeader);
    scope.querySelectorAll('[data-irh-reviews]').forEach(initRail);
    scope.querySelectorAll('[data-irh-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
